import {
  ADD_TO_CART_EVENT_NAME,
  ADD_TO_CART_EVENT_DETAIL,
  ADD_TO_CART_EVENT_BUY_NOW,
  ADD_TO_CART_DEFAULT_EVENT_TYPE,
  PRIMARY_CATEGORY,
} from '~~/constants/googleTagManager';
import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';
import type { TagProduct } from '~~/types/integrations/tagManager/TagProduct';

export const buildAddToCartTags = ({
  productTags,
  textDisplayed = '',
  triggeredIn = undefined,
  shouldOpenCart = undefined,
}: {
  productTags: TagProduct,
  textDisplayed: string,
  triggeredIn: EventSourceLocation,
  shouldOpenCart?: boolean,
}) => ({
  event: ADD_TO_CART_EVENT_NAME,
  eventInfo: {
    detail: shouldOpenCart ? ADD_TO_CART_EVENT_BUY_NOW : ADD_TO_CART_EVENT_DETAIL,
    text_displayed: textDisplayed,
    triggered_in: triggeredIn,
  },
  category: {
    event_type: ADD_TO_CART_DEFAULT_EVENT_TYPE,
    primary_category: PRIMARY_CATEGORY,
  },
  ecommerce: { items: [productTags] },
});
